import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { batch } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';

// project imports
import { useDispatch, useSelector } from 'store';
import { selectSideMenuItem, toogleSideMenuIsOpen } from 'store/slices/main';

// project hooks
import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = ({ item, level }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { user } = useAuth();
    const { borderRadius } = useConfig();
    const { selectedSideMenuItem } = useSelector((state) => state.main);
    const matchDownLg = useMediaQuery(theme.breakpoints.down('lg'));
    // const matchUpSm = useMediaQuery(theme.breakpoints.up('sm'));

    const itemTarget = item?.target ? '_blank' : '_self';
    const listItemProps = item?.external
        ? { component: 'a', href: item?.url, target: itemTarget }
        : { component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item?.url} target={itemTarget} />) };

    if (!user?.authorizations?.some((auth) => auth?.startsWith(item?.id))) {
        return <></>;
    }
    // if (item?.id === 'workmgmt-ticket-create' && matchUpSm) {
    //     return <></>;
    // }

    return (
        <ListItemButton
            {...listItemProps}
            disabled={item?.disabled}
            sx={{
                borderRadius: `${borderRadius}px`,
                mb: 0.5,
                alignItems: 'flex-start',
                backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                py: level > 1 ? 1 : 1.25,
                pl: `${level * 24}px`
            }}
            selected={selectedSideMenuItem === item?.id > -1}
            onClick={() =>
                batch(() => {
                    dispatch(selectSideMenuItem(item?.id));
                    dispatch(toogleSideMenuIsOpen(!matchDownLg));
                })
            }
        >
            <ListItemIcon sx={{ my: 'auto', minWidth: !item?.icon ? 18 : 36 }}>
                {item?.icon || (
                    <FiberManualRecordIcon
                        sx={{
                            width: selectedSideMenuItem === item?.id > -1 ? 8 : 6,
                            height: selectedSideMenuItem === item?.id > -1 ? 8 : 6
                        }}
                        fontSize={level > 0 ? 'inherit' : 'medium'}
                    />
                )}
            </ListItemIcon>
            <ListItemText
                primary={
                    <Typography variant={selectedSideMenuItem === item?.id > -1 ? 'h5' : 'body1'} color="inherit">
                        {item?.title}
                    </Typography>
                }
                secondary={
                    item?.caption && (
                        <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                            {item.caption}
                        </Typography>
                    )
                }
            />
            {item?.chip && (
                <Chip
                    color={item.chip.color}
                    variant={item.chip.variant}
                    size={item.chip.size}
                    label={item.chip.label}
                    avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
                />
            )}
        </ListItemButton>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default NavItem;
